import { z } from 'zod';

export const ConstructionMethodSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  construction_type: z.string().default('Frameless'),
  has_face_frame: z.boolean().default(false),
  face_frame_width: z.number().default(1.5),
  face_frame_material_id: z.string().uuid().nullable(),
  dado_backs: z.boolean().default(true),
  dado_depth: z.number().default(0.25),
  dowel_construction: z.boolean().default(false),
  confirm_construction: z.boolean().default(false),
  separate_top_bottom: z.boolean().default(false),
  separate_stretchers: z.boolean().default(false),
  nailer_height: z.number().default(3),
  include_nailer: z.boolean().default(true),
  toe_kick_height: z.number().default(4),
  toe_kick_depth: z.number().default(3),
  toe_kick_material_id: z.string().uuid().nullable(),
  include_toe_kick: z.boolean().default(true),
  overlay_type: z.string().default('full'),
  overlay_amount: z.number().default(0.75),
  reveal_width: z.number().default(0.125),
  scribe_left: z.number().default(0),
  scribe_right: z.number().default(0),
  scribe_top: z.number().default(0),
  scribe_bottom: z.number().default(0),
  default_box_material_id: z.string().uuid().nullable(),
  default_door_material_id: z.string().uuid().nullable(),
  default_drawer_front_material_id: z.string().uuid().nullable(),
  default_back_material_id: z.string().uuid().nullable(),
  default_shelf_material_id: z.string().uuid().nullable(),
  default_drawer_box_material_id: z.string().uuid().nullable(),
  notes: z.string().nullable(),
  active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateConstructionMethodSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  construction_type: z.string().default('Frameless'),
  has_face_frame: z.boolean().default(false),
  face_frame_width: z.number().default(1.5),
  face_frame_material_id: z.string().uuid().nullable().optional(),
  dado_backs: z.boolean().default(true),
  dado_depth: z.number().default(0.25),
  dowel_construction: z.boolean().default(false),
  confirm_construction: z.boolean().default(false),
  separate_top_bottom: z.boolean().default(false),
  separate_stretchers: z.boolean().default(false),
  nailer_height: z.number().default(3),
  include_nailer: z.boolean().default(true),
  toe_kick_height: z.number().default(4),
  toe_kick_depth: z.number().default(3),
  toe_kick_material_id: z.string().uuid().nullable().optional(),
  include_toe_kick: z.boolean().default(true),
  overlay_type: z.string().default('full'),
  overlay_amount: z.number().default(0.75),
  reveal_width: z.number().default(0.125),
  scribe_left: z.number().default(0),
  scribe_right: z.number().default(0),
  scribe_top: z.number().default(0),
  scribe_bottom: z.number().default(0),
  default_box_material_id: z.string().uuid().nullable().optional(),
  default_door_material_id: z.string().uuid().nullable().optional(),
  default_drawer_front_material_id: z.string().uuid().nullable().optional(),
  default_back_material_id: z.string().uuid().nullable().optional(),
  default_shelf_material_id: z.string().uuid().nullable().optional(),
  default_drawer_box_material_id: z.string().uuid().nullable().optional(),
  notes: z.string().nullable().optional(),
  active: z.boolean().default(true),
});

export const UpdateConstructionMethodSchema = CreateConstructionMethodSchema.partial();

export type ConstructionMethod = z.infer<typeof ConstructionMethodSchema>;
export type CreateConstructionMethod = z.infer<typeof CreateConstructionMethodSchema>;
export type UpdateConstructionMethod = z.infer<typeof UpdateConstructionMethodSchema>;
